import type { PollView } from '../../shared/polls';
import type { Announcement } from '../lib/useAnnouncements';

/**
 * Schwarzes Brett als `// schwarzes brett`-Strip am unteren Rand
 * (Design-System §6). Tap öffnet alle Ankündigungen.
 *
 * Daten und Overlay liegen beim Homescreen – der Strip zeigt nur an.
 */
export function BoardStrip({
  items,
  polls = [],
  onOpen,
}: {
  items: Announcement[] | null;
  polls?: PollView[];
  onOpen: () => void;
}) {
  // Offene, noch nicht beantwortete Abfrage geht vor (Design-System §6 „Abfrage“).
  const abfrage = polls.find((p) => p.open && !p.answered);
  const newest = items?.[0];
  const message = abfrage
    ? abfrage.title
    : items === null
      ? 'lädt …'
      : (newest?.title ?? 'Nichts angeschlagen.');

  return (
    <button
      type="button"
      className="board"
      onClick={onOpen}
      aria-haspopup="dialog"
      title="Schwarzes Brett öffnen"
    >
      <span className="board__k">{abfrage ? '// abfrage' : '// schwarzes brett'}</span>
      <span className="board__msg">{message}</span>
      <span className="board__go" aria-hidden="true">
        {abfrage ? '› antworten' : '>'}
      </span>
    </button>
  );
}
